export const selectTooltipXPos = (state) => state.trendTooltip.tooltipXPos;